// SK Queue corner radii — soft, rounded surfaces per the handoff.
// Chips/dots are pill/circular (full); controls 7–10px; cards 12–18px;
// device/phone frame uses its own large radius inline. `r2` is the common
// control radius reused by the shared primitives (buttons, inputs, chips).
export const Radii = {
  r1:   7,   // small controls (token chips, segmented cells)
  r2:   9,   // buttons, inputs, menu items
  r3:   12,  // cards, list rows
  r4:   14,  // larger cards, modals
  r5:   18,  // hero blocks, prominent cards
  full: 999, // avatars, toggles, status dots, pills
};
